import { AbstractControl, ValidatorFn } from '@angular/forms';

export function IbanMinLength(length): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const ibanValue = control.value.replace(/[_ ]/g, '');
    if (ibanValue.length < length) {
      return {
        ibanTooShort: true
      };
    } else {
      return null;
    }
  };
}
